import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Text, Box, Flex } from '@chakra-ui/react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {
//   faPlus,
//   faSearch,
//   faUserFriends,
// } from '@fortawesome/free-solid-svg-icons';
import { IconButton } from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import { IntegrationInstructions, Workspaces } from '@mui/icons-material';

function AccountSettings() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <Box p={6}>
      {/* Main Content */}
      <Text fontSize="2xl" fontWeight="bold" mb={4}>
        Account Settings
      </Text>

      <Flex wrap="wrap" gap={4} maxW="100%" p={4}>
        <Flex
          className="account-card"
          onClick={() => {
            handleNavigate('/team-management');
          }}
          alignItems={'flex-start'}
          gap={2}
          p={4}
          border="1px solid blue.500"
          shadow="xs"
          borderRadius="md"
          cursor={'pointer'}
          width={'max-content'}
          minW={"30%"}
        >
          {/* <IconButton icon={GroupIcon} style={{ color: '#2584FD' }} /> */}
          <IconButton style={{ color: '#2584FD' }}> <GroupIcon/> </IconButton>
          <Flex flexDir={'column'}>
            <Text fontSize="xl" mb={4} color={'#2584FD'} mt={1}>
              Team management
            </Text>
            <Text>Invite team members and define roles</Text>
          </Flex>
        </Flex>
        <Flex
          className="account-card"
          onClick={() => {
            handleNavigate('/collaboration-forms');
          }}
          alignItems={'flex-start'}
          gap={2}
          p={4}
          border="1px solid blue.500"
          shadow="xs"
          borderRadius="md"
          cursor={'pointer'}
          width={'max-content'}
          minW={"30%"}
        >
          {/* <IconButton icon={GroupIcon} style={{ color: '#2584FD' }} /> */}
          <IconButton style={{ color: '#2584FD' }}> <Workspaces/> </IconButton>
          <Flex flexDir={'column'}>
            <Text fontSize="xl" mb={4} color={'#2584FD'} mt={1}>
              Collaboration Forms
            </Text>
            <Text>View all collabaration forms</Text>
          </Flex>
        </Flex>
        <Flex
          className="account-card"
          onClick={() => {
            handleNavigate('/integrations');
          }}
          alignItems={'flex-start'}
          gap={2}
          p={4}
          border="1px solid blue.500"
          shadow="xs"
          borderRadius="md"
          cursor={'pointer'}
          width={'max-content'}
          minW={"30%"}
        >
          {/* <IconButton icon={GroupIcon} style={{ color: '#2584FD' }} /> */}
          <IconButton style={{ color: '#2584FD' }}> <IntegrationInstructions/> </IconButton>
          <Flex flexDir={'column'}>
            <Text fontSize="xl" mb={4} color={'#2584FD'} mt={1}>
              Integrations
            </Text>
            <Text>Super charge your workflow</Text>
          </Flex>
        </Flex>
      
      </Flex>



      {/* Profile Badge */}
      {/* <div className="profile-badge">
        <span className="profile-initials">BV</span>
      </div> */}
    </Box>
  );
}

export default AccountSettings;
